export default "__VITE_ASSET__bd9032ea__"